<template lang="pug">
v-card
    v-card-title Update Sidebar Spotify
    v-card-text
        v-container.holder
            v-card(:loading="loading")
                v-card-text
                    v-img(:src="sidebarPicture")
                    br
                    v-file-input(label="Spotify Image" v-model="form.spotifyImage" :disabled="loading")
                    v-text-field(label="Spotify Link" prepend-icon="mdi-link-variant" v-model="form.spotufyLink" :disabled="loading")
                v-card-actions
                    v-spacer
                    v-btn(color="primary" @click="onSubmit" :disabled="loading") Submit

    v-snackbar(v-model="success" top color="green")
        v-icon(left) mdi-alert-circle-outline
        | Successfully Saved!
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="success = false"
            ) Close

    v-snackbar(v-model="error.show" top color="red")
        v-icon(left) mdi-alert-circle-outline
        | {{ error.message }}
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="error.show = false"
            ) Close
        
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Config from '../../../configuration';

export default {
    data() {
        return {
            success: false,
            loading: true,
            error: {
                show: false,
                message: ''
            },
            form: {
                spotifyImage: null,
                spotufyLink: null
            }
        };
    },
    computed: {
        profileSideBarLink() {
            const profileSettings = this.settings({
                query: { option_name: 'profile_sidebar_invite_artists_link' }
            });
            return profileSettings.data[0].option_value;
        },
        sidebarPicture() {
            // https://api.breakinghits.com/public/
            // https://www.breakinghits.app/img/
            const profileSettings = this.settings({
                query: { option_name: 'profile_sidebar_invite_artists' }
            });
            if(profileSettings.data.length !== 0) {
                if(profileSettings.data[0].option_value.indexOf('http') !== -1) {
                    return profileSettings.data[0].option_value;
                } else {
                    return `https://www.breakinghits.app/img/${profileSettings.data[0].option_value}`;
                }
            } else {
                return '';
            }
        },
        ...mapGetters('bh-settings', { settings: 'find' })
    },
    async created() {
        await this.getSettings({
            query: {
                option_name: { $in: ['profile_sidebar_invite_artists', 'profile_sidebar_invite_artists_link'] }
            }
        });
        this.form.spotufyLink = this.profileSideBarLink;
        this.loading = false;
    },
    methods: {
        getOptions(option_name) {
            const settings = this.settings({
                query: { option_name }
            });
            return settings.data[0];
        },
        async onSubmit() {
            try {
                this.loading = true;
                if(this.form.spotifyImage) {
                    const profilePictureRaw = await this.toBase64(this.form.spotifyImage);
                    const profileS3File = await fetch(`${Config.host}/api/upload`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': window.localStorage.getItem('feathers-jwt')
                        },
                        body: JSON.stringify({
                            uri: profilePictureRaw
                        })
                    }).then(data => data.json());
                    const settings = this.getOptions('profile_sidebar_invite_artists');
                    settings.option_value = `https://api.breakinghits.com/public/${profileS3File.id}`;
                    await settings.patch();
                }
                const settings = this.getOptions('profile_sidebar_invite_artists_link');
                settings.option_value = this.form.spotufyLink;
                await settings.patch();
                this.success = true;
            } catch(err) {
                this.error.message = err.message;
                this.error.show = true;
            } finally {
                this.loading = false;
            }
        },
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        ...mapActions('bh-settings', { getSettings: 'find' })
    }
}
</script>

<style lang="scss" scoped>
.holder {
    max-width: 710px;
}
</style>